<template>
  <default-page>
     <section-frame title="Folklore" subTitle="むかしばなし">
      <div v-html="story.title" class="story-title wf-sawarabimincho"></div>
      <div v-html="story.contents" class="story-contents wf-sawarabimincho"></div>
      <div v-html="story.reference" class="story-reference mt-5 text-caption wf-sawarabimincho"></div>
      <!-- <link href="https://fonts.googleapis.com/earlyaccess/hannari.css" rel="stylesheet"> -->
      <link href="https://fonts.googleapis.com/css?family=Sawarabi+Mincho" rel="stylesheet">
      <v-btn outlined to="lazymaster" class="mt-10">LAZY MASTEに戻る</v-btn>
    </section-frame>
  </default-page>
</template>

<script>
import DefaultPage from '@/components/DefaultPage.vue'
import SectionFrame from '@/components/SectionFrame.vue'

export default {
    components: { DefaultPage, SectionFrame },
  data() {
    return {
      story:{
        contents:"むかしあるところに、</br>たくさんのみかん山をもつおとこがいた。</br></br>ある日のこと、</br>おとこがそれは大きなみかんをみつけると、</br>ふしぎなことに</br>中から話し声がきこえてきた。</br></br>小さな穴をあけのぞいてみると、</br>みかんの中で仙人のようないで立ちをした</br>二人の老人が囲碁を打っていた。</br></br>碁はちょうどいい勝負で、</br>おとこもたいそう碁が好きなので、</br>さらに穴を大きくして顔を入れてみると、</br>穴の反対側に座っている老人がおとこに気づき</br>おとこの目と老人の目がばちりとあった。</br></br>一瞬の沈黙のあと、</br>心の中で意気投合したおとこと老人は</br>一緒に囲碁を続けることにした。</br></br>「おじいさん、次の一手はそこに」 </br>「そうです、それはいい一手です!」 </br></br>おとこはみぶりてぶりで老人に石を置く場所を教え、</br>老人も教えられた場所に石をおいていった。</br></br>「おかしいぞ、</br>いままで一度もおぬしに負けたことはないのに」</br> 手前にすわった老人がふと気づいた。</br></br>「そういつも負けてばかりはおられぬわ。</br>今日は勝たせてもらうぞ」</br></br>向こうの老人がそう答えたそのとき、</br>手前の老人がひょいと振り向き、</br>だれが勝負を逆転させたのか気づいた。 </br></br>「あっはっはっは、おぬしやってくれたな」</br></br>しばらくのあいだ二人の老人は笑い転げていたが、</br>ずっとたちあがったかと思うと、</br>基盤の上の基石をわしづかみにして、</br>笑いながらおとこに向かってバラバラと投げかけた。</br></br>急なことに驚いたおとこが身をかわしていると、</br>いつのまにか二人の老人は</br>あとかたもなく消えていなくなり、</br>後にはぱっかりとわれた大きなみかんと、</br>種がちらばっていた。</br></br>おとこがその種をまいて育てたら、</br>今までになく甘くて大きなみかんが</br>いっぱいなったそうだ。 </br></br>おしまい。",
        title:"仙人みかん",
        reference:"(静岡県沼津市西浦木負に伝わる昔ばなし)"
      }
    }
  }

}
</script>
<style scoped>
.story-title{
  font-size: 2rem;
  line-height: 3rem;
  margin-top: 3rem;
  margin-bottom: 1rem;
}
.story-contents{
 font-size: 0.9rem; 
}
/* .wf-hannari { font-family: "Hannari"; } */
.wf-sawarabimincho { font-family: "Sawarabi Mincho"; }
</style>